<template>
  <div class="certification">
    <div class="certification-container">
      <div class="title"></div>
      <div class="manu">
        <img src="../../../../assets/moblie/images/manu2.jpg" />
      </div>
      <div class="content">
        VISUfarma是一家泛欧眼科制药公司，其使命明确：为欧洲眼部健康带来优质产品和全球治疗创新
。它们是一家历史悠久、发展迅速的眼科公司，在欧洲范围内将广泛的药品和医疗器械产品组合商
业化。
      </div>
      <div class="content">
        它们在干眼症、眼睑卫生、睑板腺功能障碍（MGD）、睑缘炎和蠕形螨管理、视网膜健
康、食品补充剂和青光眼等领域提供完整的产品组合。
      </div>
      <div class="content">
        它们不断增长的创新产品组合以及它们对眼部健康的承诺将
通过独家分销商，从世界各地引进新的治疗解决方案，帮助欧洲和全球20多个国家的患者
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ListingCertification",
  components: {},
  props: {},
  computed: {},
  data: function() {
    return {};
  },
  created() {},
  mounted: function() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.certification {
  min-height: 100%;
  background-color: rgb(72, 173, 241);
  padding: 15px 20px;
  overflow: auto;
  &-container {
    background-color: #fff;
    border-radius: 14px;
    min-height: 100%;
    overflow: auto;
    padding: 15px 15px;
    .title {
      background-image: url("../../../../assets/moblie/images/manutitle2.png");
      background-size: 100% 100%;
      width: 80%;
      height: 1.5rem;
      margin: 0 auto;
    }
    .manu {
      width: 100%;
      height: 120px;
      margin-top: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .content {
      margin-top: 10px;
      font-size: 17px;
      line-height: 28px;
      margin-bottom: 10px;
    }
    .time-line {
      &-item {
        padding: 20px 15px;
        position: relative;
        border-left: 1px solid rgb(46, 119, 196);
        .time {
          font-size: 18px;
          font-weight: 600;
          line-height: 26px;
        }
        .event {
          font-size: 16px;
        }
      }
      &-item::after {
        content: "";
        width: 10px;
        height: 10px;
        background-color: rgb(46, 119, 196);
        box-shadow: 0 0 2px 2px rgb(164, 198, 230);
        position: absolute;
        left: -5px;
        top: 27px;
        border-radius: 40px;
      }
    }
  }
}
</style>
